<template>
  <div id="data" class="data">
    <i-button type="primary" style="margin-bottom: 1.25rem" @click="addshebei">添加设备</i-button>
    <div v-for="(itme, index) in stelist" :key="itme.id" class="detailbox">
      <div class="datalist">
        <div class="datalist-left">
          <Input v-model="itme.mn" size="large" placeholder="请输入MN号" style="width: 12.5rem" />
          <Button type="primary" style="height: 2.25rem" @click="getTJInfo(index)">确定</Button>
          <Button type="warning" style="height: 2.25rem; margin-left: 0.625rem" @click="deldata(itme.gkEquip_id, index)"
            >删除</Button
          >
        </div>
        <mygongsi :site-list="itme" />
        <Modal v-model="modal1" title="删除" @on-ok="ok" @on-cancel="cancel">
          <p>你确定要删除这一条数据吗？</p>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import mygongsi from '../components/mygongsi.vue';
export default {
  components: {
    mygongsi,
  },
  props: {
    datalist: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      MN: '',
      modal1: false,
      id: '',
      stelist: [], // 内容
      yytypes: '',
    };
  },
  created() {
    this.yytypes = sessionStorage.getItem('yytype');
  },
  mounted() {
    let str = JSON.stringify(this.datalist);
    this.stelist = JSON.parse(str);
  },
  methods: {
    change(status) {
      this.$Message.info('开关状态：' + status);
    },
    deldata(id, index) {
      this.modal1 = true;
      this.id = id;
      this.listindex = index;
    },
    ok() {
      const that = this;
      const api = this.ApiUrl + 'gkEquip/delById';
      const data = {
        gkEquip_id: this.id,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success('删除成功');
            this.stelist.splice(this.listindex, 1);
          } else {
            this.$Message.error(res.data.extend.msg || '删除失败');
          }
        },
        res => {},
      );
    },
    cancel() {
      this.modal1 = false;
    },
    adddiv: function () {
      this.myxuanxiangList.push({
        id: '',
        value: '',
      });
    },
    addshebei() {
      if (this.stelist.length != 0) {
        if (this.stelist[this.stelist.length - 1].mn == '' || this.stelist[this.stelist.length - 1].mn == '默认值') {
          this.$Message.error('请填写完成设备信息在次添加新的设备');
          return;
        }
      }
      const id = sessionStorage.getItem('comid');
      const that = this;
      const api = this.ApiUrl + 'gkEquip/addGkEquip';
      const data = {
        company_id: id,
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success('添加成功');
            const shebei = {};
            if (!shebei.gkEquip_id) {
              shebei.gkEquip_id = res.data.extend.gkEquip_id;
            }
            if (!shebei.mn) {
              shebei.mn = '';
            }
            if (!shebei.sitelist) {
              shebei.sitelist = [];
            }

            this.stelist.push(shebei);
          } else {
            this.$Message.error('添加失败');
          }
        },
        res => {},
      );
    },
    getTJInfo(index) {
      const that = this;
      for (var i = 0; i < that.stelist[index].length; i++) {
        const list = that.stelist[index];
        if (list[i].mn == '' || list[i].mn == null) {
          this.$Message.error('请输入MN号');
          return;
        }
      }
      const api = this.ApiUrl + 'gkSensor/updateGkEquip';
      const data = {
        data: that.stelist[index],
        type: this.yytypes,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news == 0) {
            this.$Message.success('修改成功');
          } else {
            this.$Message.error(res.data.extend.msg);
          }
        },
        res => {},
      );
    },
  },
};
</script>

<style scoped>
.data {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.detailbox {
  border-bottom: 1px solid #ccc;
  margin-top: 20px;
}

.datalist {
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 20px;
}

.datalist-left {
  display: flex;
  width: 100%;
  flex: 1;
  margin-right: 4.875rem;
}

.datalist-left .ivu-input {
  width: 12.5rem;
}

.ivu-input-wrapper {
  width: 12.5rem;
  margin-right: 1.25rem;
}

.view-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.view-box-myxuanxiang {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.ivu-input {
  width: 12.5rem;
}

.xuanze {
  width: #666;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  margin-right: 1.25rem;
}

.view-box-myxuanxiang-in {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.view-box-top {
  width: 100%;
  display: flex;
  height: 2.25rem;
  align-items: center;
}
</style>
